"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _OneToOneChat = require("./OneToOneChat");
Object.keys(_OneToOneChat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OneToOneChat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OneToOneChat[key];
    }
  });
});